export default {
  "component": {
    "tradeInProcess": {
      "649f8aefats0": "Upłynął czas realizacji zamówienia",
      "649f8aefc1c0": "Recykling nie powiódł się",
      "649f8aefc9c0": "Uzyskaj nową wycenę",
      "TradeIn": "Proces wymiany urządzenia",
      "logistic": "Pobierz etykietę wysyłkową",
      "start": "Rozpocznij proces",
      "success": "Pomyślnie odebrałeś nowe urządzenie",
      "qc": "Kontrola jakości starego urządzenia",
      "business": "Inspekcja Twojego urządzenia zostanie zakończona w ciągu 3 dni roboczych",
      "completed": "Zakończono",
      "successfully": "Gratulacje! Proces wymiany został pomyślnie zakończony",
      "orderInfor": "Informacje o zamówieniu",
      "orderID": "Numer zamówienia wymiany",
      "orderNum": "Numer zamówienia nowego urządzenia",
      "createTime": "Data utworzenia",
      "brand": "Szacowana marka",
      "model": "Szacowany model",
      "price": "Wartość starego urządzenia",
      "bonus": "Premia",
      "reclaimFailure": "Ponieważ urządzenie nie zostało wysłane w ciągu 10 dni od otrzymania, zamówienie na recykling wygasło i zostało anulowane. Jeśli nadal chcesz przeprowadzić recykling swojego starego urządzenia, kliknij poniższy przycisk, aby sprawdzić najnowszą wycenę.",
      "total": "Cena całkowita",
      "logisticInfo": "Informacje logistyczne",
      "available": "Brak dostępnych informacji o przesyłce",
      "logisticNum": "Numer przesyłki",
      "failRey": "Przepraszamy, Twoje uczestnictwo w programie recyklingu OnePlus nie zostało pomyślnie zakończone. Jeśli planujesz recykling innych urządzeń elektronicznych, kliknij poniższy przycisk, aby uzyskać szybką wycenę!",
      "userRes": "Użytkownik odrzucił ofertę.",
      "successPrice": "Poniższa cena została ustalona po profesjonalnej inspekcji. Jeśli zgadzasz się z tą wyceną, możesz kontynuować proces wymiany. Jeśli ją odrzucisz, urządzenie zostanie odesłane w ciągu kilku dni roboczych.",
      "sure": "Akceptuj",
      "Reject": "Odrzuć",
      "congratulation": "Gratulacje! Wynik kontroli jakości bez zastrzeżeń.",
      "finPirce": "Ostateczna cena",
      "copySuccess": "Skopiowano pomyślnie",
      "copyfail": "Kopiowanie nie powiodło się",
      "sureSuccess": "Potwierdź pomyślną transakcję",
      "submitError": "Przesłanie nie powiodło się",
      "detectionResult": "Wynik inspekcji",
      "Collected": "Złóż zamówienie",
      "inTransit": "W transporcie",
      "656g0lj3sav6": "Proces recyklingu",
      "656g0lj3cd5a": "Wprowadź poprawne dane osobowe i pomyślnie złóż zamówienie",
      "656g0lj3dr9a": "Inspekcja Twojego telefonu zostanie zakończona w ciągu 48 godzin od dostarczenia do naszego centrum",
      "656g0lj3epal": "Po zakończeniu inspekcji skontaktujemy się z Tobą e-mailem z ostateczną ofertą",
      "656g0lj3pda2": "Twoja wycena",
      "656g0lj3ed3d": "Profesjonalna kontrola jakości",
      "656g0lj3esf3": "Kopiuj",
      "expertDiscount": "Kod promocyjny",
      "invalidCode": "Nieprawidłowy kod",
      "toastTip": "Zaznacz, aby zaakceptować Politykę prywatności i Warunki.",
      "649f8aef26sf": "Proces wymiany urządzenia",
      "checkTitle": "Informacje o testach",
      "basicInformation": "Informacje podstawowe",
      "understand": "Rozumiem"
    },
    "btnDialog": {
      "64a9shqq2ks0": "Odrzuć recykling",
      "64a9shqq3k00": "Potwierdzasz odmowę recyklingu",
      "64a9shqq3r00": "Anulowano pomyślnie",
      "64a9shqq3ws0": "Anulowanie nie powiodło się",
      "sureCancel": "Potwierdź anulowanie"
    }
  },

  "home": {
    "whoAreWe": {
      "646u995ltgw0": "Kim",
      "646u995lv9g0": "jesteśmy?",
      "646u9d5lv9g0": "Danghuan to firma specjalizująca się w recyklingu, utylizacji i sprzedaży urządzeń cyfrowych 3C, takich jak telefony, tablety, laptopy i smartwatche. Naszym celem jest zwiększanie efektywności recyklingu elektroniki i wspieranie rozwoju rynku urządzeń używanych. Posiadamy oficjalne partnerstwa strategiczne z markami OPPO, Vivo, OnePlus, Realme i innymi. Działamy w Indiach, Tajlandii, Wietnamie, Kambodży oraz w Europie.",
      "646u995dv9g0": "Nasza globalna obecność czyni nas partnerem strategicznym dla operatorów komórkowych, producentów i hurtowników o zasięgu międzynarodowym.",
      "646u99slv9g0": "Współpracujemy z wiodącymi producentami i utrzymujemy szeroki asortyment urządzeń – od budżetowych po premium – umożliwiając oferowanie konkurencyjnych cen i rozwiązań dopasowanych do potrzeb klientów."
    },
    "business": {
      "646v04syvpk0": "Czy jesteś zainteresowany zakupem naszego asortymentu?",
      "646v04syxs80": "W Danghuan oferujemy szeroki wybór telefonów, tabletów i smartwatchy w różnych klasach jakościowych, aby sprostać różnym potrzebom biznesowym.",
      "646v04syy6g0": "Skontaktuj się z naszym Kierownikiem ds. sprzedaży i zakupu:",
      "646v04syya80": "Chcę kupić",
      "646v04syydg0": "Wpisz swoje imię",
      "646v04syyh40": "Wpisz swój numer telefonu",
      "646v04syyyw0": "Wpisz swój adres e-mail",
      "646v0gsyz1s0": "Kraj:",
      "646v04syz1s0": "Wybierz opcję",
      "646v04syz4o0": "Przeczytałem i akceptuję",
      "646v04syzkc0": "Politykę prywatności",
      "646v04syzok0": "Skontaktuj się z nami",
      "646v04syzvo0": "Wprowadź numer telefonu",
      "646v04syzys0": "Wprowadź adres e-mail",
      "646v04sz01o0": "Wprowadź poprawny adres e-mail",
      "646v04sz04g0": "Wprowadź imię",
      "646v04sz0740": "Zaznacz pole, aby zaakceptować politykę prywatności",
      "646v04sz0a00": "Przesłano pomyślnie",
      "646v04sz0cw0": "Przesłanie nie powiodło się",
      "title1": "Przejrzysty system klasyfikacji urządzeń",
      "text1-1": "Aby wspierać Twoje decyzje zakupowe, zachęcamy do zapoznania się z naszym szczegółowym dokumentem klasyfikacji urządzeń, który opisuje standardy estetyczne i funkcjonalne każdej klasy.",
      "title2": "Wyjątkowa obsługa klienta",
      "text2-1": "Rozumiemy indywidualne potrzeby każdego klienta, dlatego nasz wielojęzyczny zespół sprzedaży oferuje spersonalizowane wsparcie i doradztwo.",
      "title3": "Zaangażowanie w zrównoważony rozwój technologiczny",
      "text3-1": "Dążymy do zwiększenia dostępu do zrównoważonych rozwiązań technologicznych na całym świecie, zapewniając wartość wszystkim interesariuszom.",
      "text3-2": "W celu uzyskania dodatkowych informacji lub złożenia próbnego zamówienia prosimy o kontakt – nasz zespół z przyjemnością pomoże Ci profesjonalnie i z troską."
    }
  },
  "components": {
    "section2": {
      "646tj9dnkk00": "Otrzymaj płatność w zaledwie 4 krokach",
      "s1": "Krok pierwszy",
      "s1t": "Spakuj urządzenie tak, aby dotarło w takim samym stanie, w jakim zostało wysłane.",
      "s2": "Krok drugi",
      "s2t": "Dostarcz paczkę do najbliższego punktu nadania.",
      "s3": "Krok trzeci",
      "s3t": "Sprawdzimy Twoje urządzenie i przygotujemy wycenę.",
      "s4": "Krok czwarty",
      "s4t": "Otrzymaj szybką płatność."
    },
    "section3": {
      "646tmse2fbo0": "Smartfony",
      "646tmse2mv00": "Bądź na bieżąco",
      "section3-text2": "Tablety",
      "section3-text4": "Smartwatche",
      "section3-text5": "Inne",
      "title": "Szybka wycena",
      "t1": "Wybierz typ urządzenia i rozpocznij wycenę – otrzymaj uczciwą ofertę.",
      "t2": "Kilka prostych kroków – skorzystaj z naszej szybkiej i wygodnej usługi recyklingu!"
    },
    "section6": {
      "646txzpazuc0": "O firmie Danghuan",
      "666txzpazuc0": "Firma specjalizująca się w recyklingu i ponownym wykorzystaniu smartfonów, tabletów oraz innych urządzeń cyfrowych. Zapewniamy prosty, bezpieczny i skuteczny proces, który umożliwia każdemu klientowi łatwe oddanie swojego starego urządzenia do recyklingu.",
      "646txzpb0rk0": "Szczegóły",
      "646txzpb0xc0": "Obsługujemy recykling 12 marek urządzeń"
    },
    "section7": {
      "646ns2k5f7k0": "Nasza usługa jest zawsze dostępna",
      "646ns2k5gmw0": "Obsługa klienta: od poniedziałku do piątku w godz. 9:00–18:00 CET (UTC+1:00), Madryt, Hiszpania",
      "646ns2k5gs40": "Wpisz swoje imię",
      "646ns2k5gx40": "Wpisz swój numer telefonu",
      "646ns2k5img0": "Wpisz swój adres e-mail",
      "646ns2k5isw0": "Napisz do nas wiadomość, zanim się skontaktujemy",
      "646ns2k5iws0": "Skontaktuj się z nami",
      "646ns2k5j140": "Wprowadź numer telefonu",
      "646ns2k5j4g0": "Wprowadź adres e-mail",
      "646ds2k5j4g0": "Adres e-mail",
      "646ns2k5j6c0": "Wprowadź poprawny adres e-mail",
      "646ns2k5j8g0": "Skontaktuj się z nami",
      "646ns2k5jak0": "NIP(C.I.F):",
      "646ns2k5jck0": "Adres",
      "646ns2s5jck0": "Calle del Hierro, 33, Planta 1 Nave 2, 28045 Madrid,Hiszpania",
      "646ns2k5jgc0": "Wprowadź imię",
      "646ns2k5ji40": "Zaznacz pole, aby zaakceptować politykę prywatności",
      "646ns2k5jk00": "Przesłano pomyślnie",
      "646ns2k5jm80": "Przesłanie nie powiodło się",
      "646ny1rgz3c0": "Przeczytałem i akceptuję ",
      "646ny1rh2k40": "Politykę prywatności"
    },
    "successMain": {
      "647qmd42l1s0": "Zamówienie zostało przyjęte!",
      "647qmd42mss0": "Zwróć uwagę na wiadomość e-mail z instrukcjami wysyłki, wysłaną z adresu no-reply@danghuan.eu. Jeśli jej nie otrzymałeś, sprawdź folder SPAM lub skontaktuj się z obsługą klienta pod adresem insta360@danghuan.eu.",
      "647qmd42mz80": "Nasza oferta",
      "647qmd42yeo0": "Wskazówki przed wysyłką",
      "orderTime": "Data zamówienia",
      "text1": "Darmowa wysyłka",
      "text2": "Sprawdź dokument wysyłkowy przesłany na Twój adres e-mail.",
      "text3": "Kopia zapasowa danych",
      "text4": "Aby chronić swoje dane, wykonaj kopię zapasową, usuń dane lub zresetuj urządzenie do ustawień fabrycznych.",
      "text5": "Naładuj",
      "text6": "Prosimy o naładowanie telefonu do co najmniej 1% przed wysyłką, co przyspieszy proces inspekcji.",
      "downloadDec": "Prosimy pobrać Deklarację Integralności."
    },
    "tradeInProcess": {
      "649f8aefats0": "Upłynął czas realizacji zamówienia",
      "649f8aefc1c0": "Recykling nie powiódł się",
      "649f8aefc9c0": "Uzyskaj nową wycenę",
      "TradeIn": "Proces wymiany urządzenia",
      "logistic": "Pobierz etykietę wysyłkową",
      "start": "Rozpocznij proces",
      "success": "Pomyślnie odebrałeś nowe urządzenie",
      "qc": "Kontrola jakości starego urządzenia",
      "business": "Inspekcja Twojego urządzenia zostanie zakończona w ciągu 3 dni roboczych",
      "completed": "Zakończono",
      "successfully": "Gratulacje! Proces wymiany został pomyślnie zakończony",
      "orderInfor": "Informacje o zamówieniu",
      "orderID": "Numer zamówienia recyklingu",
      "orderNum": "Numer zamówienia nowego urządzenia",
      "createTime": "Data utworzenia",
      "brand": "Szacowana marka",
      "model": "model",
      "price": "Wartość starego urządzenia",
      "bonus": "Premia",
      "total": "Cena całkowita",
      "logisticInfo": "Informacje logistyczne",
      "available": "Brak dostępnych informacji o przesyłce",
      "logisticNum": "Numer przesyłki",
      "failRey": "Przepraszamy, Twoje uczestnictwo w programie recyklingu OnePlus nie zostało pomyślnie zakończone. Jeśli planujesz recykling innych urządzeń elektronicznych, kliknij poniższy przycisk, aby uzyskać szybką wycenę!",
      "userRes": "Użytkownik odrzucił ofertę.",
      "successPrice": "Poniższa cena została ustalona po profesjonalnej inspekcji. Jeśli zgadzasz się z tą wyceną, możesz kontynuować proces wymiany. Jeśli ją odrzucisz, urządzenie zostanie odesłane w ciągu kilku dni roboczych.",
      "sure": "Akceptuj",
      "Reject": "Odrzuć",
      "congratulation": "Gratulacje! Wynik kontroli jakości bez zastrzeżeń.",
      "finPirce": "Ostateczna cena",
      "copySuccess": "Skopiowano pomyślnie",
      "copyfail": "Kopiowanie nie powiodło się",
      "sureSuccess": "Potwierdź pomyślną transakcję",
      "submitError": "Przesłanie nie powiodło się",
      "detectionResult": "Wynik inspekcji",
      "Collected": "Odebrano",
      "inTransit": "W transporcie / Wysyłka",
      "understand": "Rozumiem",
      '656g0lj3sf6e': 'Bonus promocyjne są oferowane i zarządzane przez powiązane marki. Będą wypłacane osobno i nie stanowią części wyceny starego urządzenia.'
    },
    "btnDialog": {
      "64a9shqq2ks0": "Odrzuć recykling",
      "64a9shqq3k00": "Potwierdzasz odmowę recyklingu",
      "64a9shqq3r00": "Anulowano pomyślnie",
      "64a9shqq3ws0": "Anulowanie nie powiodło się",
      "sureCancel": "Potwierdź anulowanie"
    }
  },
  "shippingLable": {
    "shippingLable": {
      "firstStep": "Dane osobowe",
      "649fhwp9zbo0": "Prześlij wyraźne zdjęcie paczki",
      "649fhwpa1900": "Pobierz etykietę wysyłkową",
      "649fhwpa1l00": "Pobierz etykietę wysyłkową",
      "649fhwpa1tc0": "Dostawa zakończona",
      "649fhwpa2100": "Zdjęcie paczki i Oświadczenie uczciwości",
      "649fhwpa2880": "Przykład umieszczenia etykiety wysyłkowej",
      "649fhwpa2h80": "Uwaga",
      "649fhwpa2qk0": "Pakowanie: Owiń telefon folią bąbelkową i wypełnij pudełko gazetą lub materiałem ochronnym, aby zapobiec uszkodzeniom w transporcie.",
      "649fhwpa2xs0": "Wypełnij puste przestrzenie materiałem zabezpieczającym.",
      "649fhwpa3fk0": "Etykieta wysyłkowa: Przynieś etykietę (cyfrową lub drukowaną) do punktu nadania – etykieta zostanie wydrukowana na miejscu.",
      "649fhwpa3v40": "Wyślij używany telefon jak najszybciej. Jeśli przesyłka nie zostanie wysłana w ciągu 10 dni, zamówienie zostanie anulowane.",
      "649fhwpa42s0": "Sprawdź punkty nadania",
      "649fhwpa4as0": "Pobierz etykietę",
      "649fhwpa4jo0": "Prześlij",
      "649fhwpa4ok0": "Strona główna",
      "649fhwpa4to0": "Przesłano pomyślnie",
      "649fhwpa4yk0": "Gratulacje! Pobieranie zakończone sukcesem!",
      "649fhwpasf3s": "Uwaga",
      "649fhwpaa6f3": "Wydrukuj i podpisz Oświadczenie uczciwości, następnie zrób zdjęcie wraz z zapakowanym urządzeniem i prześlij je."
    }
  },
  "bottom": {
    "index": {
      "646d51qugz40": "Media społecznościowe",
      "646d71qugz40": "Szybka płatność",
      "646u51qugz40": "Logistyka",
      "646u5dqui780": "Polityka prywatności",
      "646uddqui780": "Warunki użytkowania",
      "646u51qui780": "FAQ"
    }
  },
  "head": {
    "index": {
      "646nt7hwh0c0": "O Danghuan",
      "646ntjwmn580": "Biznes",
      "646nt7hwils0": "Kontakt",
      "646nt7hwipg0": "Kup",
      "646nt7hwis00": "Sprzedaj"
    }
  },
  "PCModelList": {
    "index": {
      "646wfv5g0ro0": "Darmowa wycena"
    }
  },
  "PCSearch": {
    "index": {
      "646wgb1ni8k0": "Wpisz model, który chcesz sprzedać",
      "646wgb1nj8o0": "搜索词",
      "646wgb1nji80": "我触发搜索上拉了",
      "empty": "Przykro nam, taki model nie istnieje",
      "confirm": "Potwierdź",
      "cancle": "Anuluj",
      "dialogText": "Czy na pewno chcesz usunąć całą historię wyszukiwania?"
    }
  },
  "PCProduct": {
    "empty": "Przykro nam, taki model nie istnieje"
  },
  "PCBrandTab": {
    "index": "Marka"
  },
  "PCCategoryTab": {
    "index": "Kategoria"
  },
  "PCOrderStep": {
    "index": {
      "646xagqwff40": "Zamów online",
      "646xagqwkuw0": "Darmowa wysyłka",
      "646xagqwmao0": "Testowanie",
      "646xagqwmlc0": "Szybka płatność"
    }
  },
  "PCBreadNav": {
    "index": {
      "646xgup6ugg0": "Strona główna"
    }
  },
  "router": {
    "selectModel": "Modele",
    "selectProperty": "Problemy z urządzeniem",
    "price": "Szacowana cena",
    "priceOrder": "Złóż zamówienie",
    "orderSuccess": "Zamówienie złożone pomyślnie"
  },
  "PCDeviceInfo": {
    "index": {
      "646ymq6orm00": "Wybierz model ponownie",
      "646ymq6ot0k0": "Przypomnienie",
      "646ymq6pd100": "Przed wysyłką upewnij się, że wylogowałeś się z konta w chmurze",
      "646ymq6pekw0": "usunąłeś blokadę ekranu / Apple ID z urządzenia."
    }
  },
  "PCModelInfo": {
    "index": {
      "646yn085ljk0": "Wybierz stan urządzenia",
      "647h1f4yr6c0": "Szacowana cena",
      "647h1f4yso80": "Szacowana premia",
      "text1": "Darmowa wysyłka",
      "text2": "Oferujemy darmową logistykę i wysyłkę",
      "text3": "Natychmiastowa płatność",
      "text4": "Dokonamy płatności w ciągu 3 dni roboczych po otrzymaniu urządzenia.",
      "64tve23zt0g0": "Darmowa wysyłka i zestaw do sprzedaży",
      "64tve23zup00": "Bezpieczne usuwanie danych",
      "64tve23zuy40": "Nie jesteś zadowolony? Darmowy zwrot",
      "64tve23zv7g0": "Płatność zostanie zrealizowana w ciągu 3 dni roboczych po otrzymaniu urządzenia",
      "64tve23zvbg0": "Wybierz metodę dostawy",
      "64tve23zvf80": "Masz 10 dni na dostarczenie telefonu.",
      "64tve23zvjc0": "Pobierz darmową etykietę wysyłkową i wyślij telefon",
      "64tve23zvms0": "Otrzymasz etykietę wysyłkową na e-mail",
      "64tve23zvqg0": "Uwaga:",
      "64tve23zvyo0": "ze względu na przepisy dotyczące transportu baterii litowych nie wysyłaj telefonu, jeśli podejrzewasz uszkodzenie lub wadę baterii.",
      "64tve23zwak0": "Nie zwracamy żadnych akcesoriów ani opakowań wysłanych z urządzeniem.",
      "64tve23zwgs0": "Kolejne kroki sprzedaży telefonu",
      "64tve23zwm80": "Wpisz dane kontaktowe",
      "64tve23zwt00": "Przygotuj telefon do wysyłki",
      "64tve23zwwk0": "Po dostarczeniu urządzenia zostanie ono sprawdzone. Jeśli podane informacje będą nieprawidłowe, otrzymasz nową ofertę. Możesz ją zaakceptować lub bezpłatnie odzyskać telefon."
    }
  },
  "PCPropertyList": {
    "index": {
      "646ynp3udds0": "购买渠道",
      "646ynp3ueas0": "需要激活，无法正常通话",
      "646ynp3uehw0": "Wpisz numer IMEI",
      "646ynp3uem40": "Wybierz *#06# na klawiaturze, aby sprawdzić numer IMEI telefonu."
    }
  },
  "PCButton": {
    "index": {
      "646zhxujd5g0": "Zobacz ofertę"
    }
  },
  "PCBottomButton": {
    "index": {
      "647hqss75ac0": "Uwaga: ceny telefonów i urządzeń elektronicznych mogą spaść nawet o 6 %, dlatego zalecamy wysłanie paczki jak najszybciej.",
      "647hqss760c0": "Przeczytałem i akceptuję",
      "647hqss764w0": "Politykę prywatności",
      "647hqss76ac0": "Warunki użytkowania",
      "647hqss76dg0": "Wyślij",
      "647hqss76gw0": "Razem",
      "text1": "Razem",
      "text2": "Szacowana cena",
      "text3": "Szacowana premia",
      "dialogTitle": "Powiadomienie",
      "dialogText": "Kliknij POTWIERDŹ, a następnie sprawdź e-mail, aby przejść do kolejnego kroku.",
      "dialogBtn": "POTWIERDŹ"
    }
  },
  "PCUserInfo": {
    "index": {
      "647kboa03ks0": "Informacje o zamówieniu",
      "647kboa06ys0": "Imię i nazwisko",
      "647kboa0d6v8": "Kod kraju",
      "647kboa078s0": "Telefon",
      "647kboa07d00": "Adres",
      "647kboa07jk0": "Kraj",
      "647kboa07p80": "Wybierz",
      "647kboa08b40": "Kod pocztowy",
      "647kboa08h00": "Miasto",
      "647kboa08zc0": "Adres",
      "647kboa09440": "Dane bankowe",
      "647kboa096w0": "Weryfikacja e-mail",
      "647kboa09ao0": "E-mail",
      "647kboa09dk0": "Kod weryfikacyjny",
      "647kboa09u40": "Wpisz",
      "647kboa09z80": "Wyślij",
      "647kboa0ak00": "Nieprawidłowy format adresu e-mail",
      "647kboa0aog0": "Wysłano pomyślnie",
      "send": "Wysłano",
      "submit": "Wyślij",
      "error": "Nieprawidłowy kod weryfikacyjny",
      "64jjt96fg400": "Wprowadź kod weryfikacyjny",
      "64jjt96fki00": "Pobierz kod weryfikacyjny",
      "idNumber": "Numer dowodu osobistego / ID",
      "declaration": "Oświadczenie uczciwości",
      "download": "Pobierz",
      "647kboa0idc0": "Dokument tożsamości",
      "647kboa0idc1": "(oficjalny numer identyfikacyjny wydany przez Twój kraj, używany w celach prawnych, podatkowych lub administracyjnych. Może to być Twój numer DNI, NIE, Numer identyfikacji podatkowej (NIP), Numer dowodu osobistego, CNP, lub inny równoważny dokument krajowy, w zależności od kraju zamieszkania).",
      "647kboa0idc2": "(oficjalny numer identyfikacyjny wydany przez Twój kraj, używany w celach prawnych, podatkowych lub administracyjnych. Może to być Twój numer DNI, NIE, Numer identyfikacji podatkowej (NIP), Numer dowodu osobistego, CNP, lub inny równoważny dokument krajowy, w zależności od kraju zamieszkania).",
      "idError": "Nieprawidłowy numer ID",
      "ibanTip": "Używany do otrzymania płatności za stare urządzenie.",
      "addreddPlaceholder": "To pole obsługuje maksymalnie 105 znaków"
    }
  },
  "successOrder": {
    "successOrder": {
      "647s39cv77s0": "Strona główna",
      "notRecyclable": "Ten typ urządzenia nie podlega recyklingowi",
      "IKnow": "Rozumiem",
      "tips": "Wskazówki"
    }
  },

  "blog": {
    "blogList": {
      "64wgr171lsk0": "Wyświetlenia",
      "64wgr171nq40": "Brak powiązanych treści.",
      "64wgr171av65": "Data"
    },
    "blogDetail": {
      "64wgr9y5r7s0": "Wyświetlenia",
      "64wgr171wdx9": "Szczegóły"
    }
  },

  "cookieNotice": {
    "title": "Informacja o plikach cookie",
    "description": "Korzystając z tej witryny, zgadzasz się na naszą Politykę plików cookie.",
    "cookiePolicy": "Polityka plików cookie",
    "acceptAll": "Akceptuj wszystkie pliki cookie",
    "acceptNecessary": "Akceptuj tylko niezbędne pliki cookie",
    "customize": {
      "title": "Wybierz rodzaje plików cookie, które chcesz zaakceptować:",
      "necessary": {
        "label": "Niezbędne pliki cookie",
        "description": "Te pliki cookie są niezbędne do działania witryny i nie mogą zostać wyłączone."
      },
      "analytics": {
        "label": "Analityczne pliki cookie",
        "description": "Te pliki cookie pomagają nam zrozumieć, w jaki sposób użytkownicy korzystają z naszej strony."
      },
      "marketing": {
        "label": "Marketingowe pliki cookie",
        "description": "Te pliki cookie śledzą aktywność użytkowników w Internecie, aby wyświetlać dopasowane reklamy."
      }
    },
    "save": "Zapisz ustawienia",
    "cancel": "Anuluj"
  }
}